// extracted by mini-css-extract-plugin
module.exports = {"pdfPagination":"_99y22ezkkek3fsO4iE79I","pdfPaginationButton":"_354o7NgBwPE84LX_lUFFVf","pdfPaginationPageNumber":"_8zoA1jM_sWp0EFvipPIR0"};